<template>
  <div class="loader-wrapper">
    <div
      class="spring-spinner"
      :style="
        'border-right-color:' + color + ';border-top-color: ' + color + ';'
      "
    >
      <div class="spring-spinner-part top">
        <div
          class="spring-spinner-rotator"
          :style="
            'border-right-color:' + color + ';border-top-color: ' + color + ';'
          "
        ></div>
      </div>
      <div class="spring-spinner-part bottom">
        <div
          class="spring-spinner-rotator"
          :style="
            'border-right-color:' + color + ';border-top-color: ' + color + ';'
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from "vue";

type GreenifiedLoaderProps = {
  color: string;
};

withDefaults(defineProps<GreenifiedLoaderProps>(), {
  color: "black",
});
</script>

<style scoped>
.loader-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
}

.spring-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 50%;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  height: calc(40px / 2);
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 40px;
  height: 40px;
  border: calc(20px / 7) solid transparent;
  border-right-color: #333;
  border-top-color: #333;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

@keyframes spring-spinner-animation {
  0% {
    border-width: calc(40px / 7);
  }
  25% {
    border-width: calc(40px / 23.33);
  }
  50% {
    transform: rotate(115deg);
    border-width: calc(40px / 7);
  }
  75% {
    border-width: calc(40px / 23.33);
  }
  100% {
    border-width: calc(40px / 7);
  }
}
</style>
